import { useAppSelector } from '@frontend/common';
import { changeFilter, changeFilters, ListInfo, listStore } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FilterProps } from './filter.component';

interface ViewProps {
    showFilters: boolean;
    setShowFilters: (value: boolean) => void;

    filterValues: {
        key: string;
        value: string[] | null;
    }[];
    removeFilter: (key: string, value: string) => void;
}

const useFilter = <T extends object & { id: string }>(props: FilterProps<T>): ViewProps => {
    const store = useAppSelector(useSelector, listStore);
    const list: ListInfo | undefined = store[props.listId];
    const [showFilters, setShowFilters] = useState<boolean>(false);

    useEffect(() => {
        if (props.filter?.defaultValues) props.dispatch(changeFilters(
            {
                listId: props.listId,
                filters: Array.from(props.filter.defaultValues).map(([key, value]) => {
                    return {
                        key: key.toString(),
                        value: Array.isArray(value) ? value : [value],
                    };
                })
            }
        ));
    }, [props.filter?.defaultValues])

    const removeFilter = (key: string, value: string) => {
        if (!list || !list.filter || !list.filter[key]) return;
        const currentValues = Array.isArray(list.filter[key]) ? list.filter[key] : [];
        const newValues = currentValues.filter((v) => v !== value);
        if (newValues.length === 0) {
            delete list.filter[key];
        } else {
            list.filter[key] = newValues;
        }
        props.dispatch(changeFilter(
            {
                listId: props.listId,
                key,
                value: newValues,
            }
        ));
    };

    return {
        showFilters,
        setShowFilters,
        filterValues: list?.filter && typeof list.filter === 'object'
            ? Object.keys(list.filter).map((key) => {
                const value = list.filter ? list.filter[key] : null;
                return {
                    key: key.toString(),
                    value: Array.isArray(value) ? value : null,
                };
            }).filter((f) => f.value && f.value.length > 0)
            : [],
        removeFilter
    };
};

export default useFilter;
